
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";

import ConsultaCategorias from '../../../../../lib/json/consultas/Categorias.json'
import ConsultaFormularioCRM from '../../../../../lib/json/consultas/FormularioCRM.json'
import ConsultaEtapas from '../../../../../lib/json/consultas/Etapas.json'
import ConsultaPerguntas from '../../../../../lib/json/consultas/Perguntas.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import { ConsultaAPI } from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import { CancelarButton } from "../../../../components/SubmitForm/styles";
import ResponsiveDataTable from "../../../../components/DataTable";
import SelectDinamico from "../../../../components/SelectDinamico";
import SelectFixo from "../../../../components/SelectFixo";
import { HRDivider } from "./styles";

function FichaCategoria(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idCategoria } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaFormularioCRM.consulta + (idCategoria ? ` WHERE CategoriasId = '${idCategoria}' ORDER BY Ordem` : '');
    var consultaCategoria  = ConsultaCategorias.consulta + (idCategoria ? ` WHERE Id = '${idCategoria}'` : '');
    
    const [campoDescricao, setCampoDescricao]   = useState("");
    const [campoOrdem, setCampoOrdem]   = useState(0);
    const [campoPergunta, setCampoPergunta]   = useState({value: "", label: "Selecione..."});
    const [campoEtapa, setCampoEtapa]   = useState({value: "", label: "Selecione..."});
    const [campoAcesso, setCampoAcesso] = useState({value: 'S', text: 'Sim'});
    
    const [campoTipoRegra, setCampoTipoRegra] = useState({value: '0', text: 'S/ Regra'});
    const [campoTabela, setCampoTabela] = useState({value: '0', text: 'Selecione o Campo...'});
    const [campoAcao, setCampoAcao] = useState({value: '0', text: 'Selecione a Ação...'});
    const [campoFunil, setCampoFunil]   = useState({value: "", label: "Selecione..."});
    const [campoEtapaDestino, setCampoEtapaDestino]   = useState({value: "", label: "Selecione..."});
    const [campoResposta, setCampoResposta]   = useState("");
    const [dataItem, setDataItem]   = useState([]);

    useEffect(() => {
        if (idCategoria){
            setInclusao(false)
            loadCategoria();
        }
    }, []);

    // Processa consulta do grid
    const loadCategoria = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaCategoria );
        
        if (retConsulta.data){
            let cSequencia = retConsulta.data[0].RespeitaSequencia || 'S'
            setCampoDescricao(retConsulta.data[0].Descricao);
            setCampoOrdem(retConsulta.data[0].Ordem);
            setCampoAcesso( {value: cSequencia, text: cSequencia === 'S' ? 'Sim': 'Não'} );
                
            var retItens = await ConsultaAPI( consultaDefault );
            
            if (retItens.data){
                let dados = retItens.data

                let dadosQuestionario = dados.map( (formulario) => {
                    return { 
                        dadosGrid: formulario.Descricao || formulario.EtapasDescricao,
                        descricao: formulario.Descricao, 
                        pergunta: formulario.Pergunta, 
                        etapasId: formulario.EtapasId, 
                        etapasDescricao: formulario.EtapasDescricao, 
                        tipoRegra: {value: formulario.TipoRegra.toString(), text: formulario.TipoRegraDescricao}, 
                        acao: {value: formulario.Acao.toString(), text: formulario.AcaoDescricao}, 
                        perguntaRegra: {value: formulario.PerguntaIdRegra, label: formulario.PerguntaDescricaoRegra}, 
                        resposta: formulario.Resposta, 
                        campoSistema: {value: formulario.CampoTabela , text: formulario.CampoTabelaDescricao}, 
                        categoriaDestino: {value: formulario.CategoriaIdDestino, label: formulario.CategoriaDescricaoDestino}, 
                        etapaDestino: {value: formulario.EtapaIdDestino, label: formulario.EtapaDescricaoDestino}, 
                        deletado: false, 
                        id: formulario.Id,

                    }
                })
    
                setDataItem(dadosQuestionario);                
            }
        }
        
        setCarregar(false);
    }

    const btnIncluirItem = () => {
        if (campoEtapa.value === ""){
            toast.warning('Necessário escolher uma Pergunta ou uma Etapa.');
            return;
        }
        
        if (campoEtapa.value != "" ){
            setDataItem((prevData) => [...prevData, { 
                pergunta: null, 
                descricao: null, 
                dadosGrid: campoEtapa.label,
                etapasId: campoEtapa.value, 
                etapasDescricao: campoEtapa.label, 
                tipoRegra: campoTipoRegra, 
                acao: campoAcao, 
                perguntaRegra: campoPergunta, 
                resposta: campoResposta, 
                campoSistema: campoTabela, 
                categoriaDestino: campoFunil, 
                etapaDestino: campoEtapaDestino, 
                deletado: false, 
                id: 0 
            }]);
        }

        btnCancelarItem()
    };

    const btnCancelarItem = () => {
        setCampoPergunta({value: "", label: "Selecione..."})
        setCampoEtapa({value: "", label: "Selecione..."})
        setCampoTipoRegra({value: '0', text: 'S/ Regra'})
        setCampoAcao({value: '0', text: 'Selecione a Ação...'});
        limpaRegras()
    }

    const handleExcluirItem = (row) => {
        const deletar = row.original.dadosGrid;
        
        let dados = [...dataItem]
        dados.forEach((item) => { 
            if (item.dadosGrid === deletar){ 
                item.deletado = true 
            } 
            return item 
        })

        const newData = dados;
        setDataItem(newData);
    };

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo Descrição é obrigatório.');
            return false;
        }
        if (!campoOrdem) {
            toast.warning('O prenchimento do campo Ordem é obrigatório.');
            return false;
        }

        try {
            setCarregar(true);
            const rota = 'categorias' + (inclusao ? '' : '/' + idCategoria);
    
            let jsonSalvar = {
                descricao: campoDescricao,
                ordem: campoOrdem,
                sequencia: campoAcesso.value,
                formulario: dataItem
            }

            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, jsonSalvar)
                : ConsumoAPI_PUT(rota, jsonSalvar));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    const handleTipoRegra = (e) => {
        setCampoTipoRegra(e)

        limpaRegras()

        if (e.value == '3'){
            setCampoAcao({value: '1', text: 'Gerar Evento em Novo Funil'});
        }else{
            setCampoAcao({value: '0', text: 'Selecione a Ação...'});
        }
    }

    const limpaRegras = () => {
        setCampoPergunta({value: "", label: "Selecione..."});
        setCampoFunil({value: "", label: "Selecione..."});
        setCampoEtapaDestino({value: "", label: "Selecione..."});
        setCampoTabela({value: '0', text: 'Selecione o Campo...'});
        setCampoResposta("");
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Funil CRM"/>
            </Col>
            <Col md="8" xs="12">
                <InputGeral 
                    label="Descrição"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
                />
            </Col>
            <Col md="2" xs="12">
                <InputGeral 
                    label="Ordem"
                    tipo='numero'
                    value={campoOrdem}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoOrdem(e.target.value)}
                />
            </Col>
            <Col md="2" xs="12">
                <SelectFixo 
                    options={[{value: 'S', text: 'Sim'}, {value: 'N', text: 'Não'}]} 
                    value={campoAcesso} 
                    selectedOptionValue={campoAcesso} 
                    isLabel={true} 
                    label="Acesso Seq.: " 
                    onChange={(e) => setCampoAcesso(e)}
				/>
            </Col>
        </Row>
        <HRDivider></HRDivider>
        <Row>
            <Col md="10" xs="12">
                <h5>Etapas do Funil: </h5>
            </Col>
        </Row>
        <Row>
            <Col md="12" xs="12">
                <SelectDinamico 
                    label="Etapas"
                    consulta={ConsultaEtapas.consulta}
                    tabela={ConsultaEtapas.tabelas}
                    cValue="Id"
                    cText='Id + " - " + item.Descricao'
                    isMultiplo={false}
                    value={campoEtapa}
                    campoValue={campoEtapa}
                    onchange={(e) => setCampoEtapa(e)}
                    showNoFilter={false}
                />
            </Col>
            <Col md="6" xs="12">
                <SelectFixo 
                    options={[
                        {value: '0', text: 'S/ Regra'}, 
                        {value: '1', text: 'Ao Criar Etapa'}, 
                        {value: '2', text: 'Ao Finalizar Etapa'},
                        {value: '3', text: 'Definir Proxima Etapa de acordo com Resposta'},
                        {value: '4', text: 'Preencher Dados de acordo com Resposta'}
                    ]}
                    value={campoTipoRegra} 
                    selectedOptionValue={campoTipoRegra} 
                    isLabel={true} 
                    label="Tipo Regra: " 
                    onChange={(e) => handleTipoRegra(e)}
                    disabled={campoEtapa.value == ""}
                />
            </Col>

            {/* Novos Campos - Ação, IdPergunta, Resposta, Funil, Etapa, E-mail */}
            { "3,4".includes(campoTipoRegra.value) &&
                <Col md="12" xs="12">
                    <SelectDinamico 
                        label="Pergunta da Etapa"
                        consulta={ConsultaPerguntas.consulta + ` WHERE Id IN (SELECT Pergunta FROM FormularioCRM WHERE EtapasId = '${campoEtapa.value}')`}
                        tabela={ConsultaPerguntas.tabelas}
                        cValue="Id"
                        cText='Id + " - " + item.Descricao'
                        isMultiplo={false}
                        value={campoPergunta}
                        campoValue={campoPergunta}
                        onchange={(e) => setCampoPergunta(e)}
                        showNoFilter={false}
                    />
                </Col>
            }

            { campoTipoRegra.value == "3" &&
                <Col md="12" xs="12">
                    <InputGeral 
                        label="Resposta"
                        tipo='text'
                        value={campoResposta}  // Define o valor do campo com base no estado
                        onChange={(e) => setCampoResposta(e.target.value)}
                    />
                </Col>      
            }

            { campoTipoRegra.value == "4" &&
                <Col md="12" xs="12">
                    <SelectFixo 
                        options={[
                            {value: '0', text: 'Selecione o Campo...'}, 
                            {value: 'Cliente', text: 'Cliente/Contato'}, 
                            {value: 'Orcamento', text: 'Nº Orçamento'}, 
                            {value: 'Titulo', text: 'Titulo Proposta'}, 
                            {value: 'ResponsavelComercial', text: 'Responsável Comercial'},
                            {value: 'ResponsavelOrcamento', text: 'Responsável Orçamento'},
                            {value: 'RevisaoTecnica', text: 'Revisão Técnica / Comercial'}
                        ]}
                        value={campoTabela} 
                        selectedOptionValue={campoTabela} 
                        isLabel={true} 
                        label="Ação: " 
                        onChange={(e) => setCampoTabela(e)}
                    />
                </Col>      
            }

            {  '1/2'.includes(campoTipoRegra.value) &&
                <Col md="6" xs="12">
                    <SelectFixo 
                        options={[
                            {value: '0', text: 'Selecione a Ação...'}, 
                            {value: '1', text: 'Gerar Evento em Novo Funil'}, 
                            {value: '2', text: 'Disparar E-mail'}, 
                            {value: '3', text: 'Encerrar Processo CRM'}
                        ]}
                        value={campoAcao} 
                        selectedOptionValue={campoAcao} 
                        isLabel={true} 
                        label="Ação: " 
                        onChange={(e) => setCampoAcao(e)}
                    />
                </Col>
            }
            
            {  campoAcao.value == "1" && (
                <>
                    <Col md="12" xs="12">
                        <SelectDinamico 
                            label="Funil Destino"
                            consulta={ConsultaCategorias.consulta + ` WHERE Id != '${idCategoria || '0'}'`}
                            tabela={ConsultaCategorias.tabelas}
                            cValue="Id"
                            cText='Id + " - " + item.Descricao'
                            isMultiplo={false}
                            value={campoFunil}
                            campoValue={campoFunil}
                            onchange={(e) => setCampoFunil(e)}
                            showNoFilter={false}
                        />
                    </Col>  
                    <Col md="12" xs="12">
                        <SelectDinamico 
                            label="Etapas Destino"
                            consulta={ConsultaEtapas.consulta + ` WHERE Id IN (SELECT EtapasId FROM FormularioCRM WHERE CategoriasId = '${campoFunil.value}')`}
                            tabela={ConsultaEtapas.tabelas}
                            cValue="Id"
                            cText='Id + " - " + item.Descricao'
                            isMultiplo={false}
                            value={campoEtapaDestino}
                            campoValue={campoEtapaDestino}
                            onchange={(e) => setCampoEtapaDestino(e)}
                            showNoFilter={false}
                            disabled={campoFunil.value == ""}
                        />
                    </Col>
                </>
            )}

            <Col md="4" xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                <Col md="6" xs="12">
                    <Button className="w-100" variant="primary" onClick={btnIncluirItem}>✚ Adicionar</Button>
                </Col>
                <Col md="6" xs="12">
                    <CancelarButton className="w-100" variant="danger" onClick={btnCancelarItem}>✗ Cancelar</CancelarButton>
                </Col>
            </Col>
        </Row>

        {dataItem && dataItem.length > 0 && (
            <ResponsiveDataTable 
                habilitaBuscar={false} 
                columns={[{Header: 'Formulário',accessor: 'dadosGrid'}]} 
                data={dataItem.filter(item => item.deletado === false)} 
                isIgnorar={true}
                buttons= {[
                    {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                ]}
            />
        )}
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaCategoria;